import Headroom from 'headroom.js';

document.addEventListener("DOMContentLoaded", function(event) { 
    const header = document.querySelector('.header');
    const headSection = document.querySelector('.head-images, .big-slider');

    if (header) {

        let offset = header.clientHeight;
        if (headSection) {
            // offset = offset + headSection.clientHeight;
        }
        
        const headroom = new Headroom(header, {
            // vertical offset in px before element is first unpinned
            offset: offset,
            // scroll tolerance in px before state changes
            tolerance: {
                up: 5,
                down: 0,
            },
        });
        headroom.init();
    }
});

